const CCSManagerActions = {
  SET_SELECTED_CUSTOMER: 'SET_SELECTED_CUSTOMER',
  SET_SELECTED_USER: 'SET_SELECTED_USER',
  SET_USER_CCS_ROLES: 'SET_USER_CCS_ROLES',
  SET_SELECTED_DEVICE_CUSTOMER_DATA: 'SET_SELECTED_DEVICE_CUSTOMER_DATA'
}

export default CCSManagerActions
